import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { calculateGridHeight, showNotification } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      if (String(value).length > 100) {
        callback(
          new Error(
            'Analysis type must be less than or equals to 100 characters',
          ),
        )
      } else {
        callback()
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      spinner: false,
      defaultSortedBy: 'analysisType',
      defaultSortOrder: true,
      page: 0,
      pageSize: null,
      analysisList: [],
      loadRefresh: false,
      gridOptions: null,
      columnDefs: [],
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      loading: true,
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        analysisType: undefined,
        isActive: 1,
      },
      rules: {
        analysisType: [
          {
            required: true,
            message: 'Please enter analysis type',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      filters: {},
      tableState: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadConfig()
  },
  mounted() {
    this.$root.$on('editType', this.getTypeById)
    window.addEventListener('resize', this.getWindowSize)
  },
  beforeDestroy() {
    this.$root.$off('editType')
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '1') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.loading = true
        this.analysisList = []
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  methods: {
    loadConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.columnDefs = gridProperties.master.columns.analysisType
      this.frameworkComponents = gridProperties.master.frameworks
    },

    // Refresh Analysis Types
    refreshTypes() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.analysisList = []
      this.page = 0
      this.defaultSortedBy = 'analysisType'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'analysisType',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getTypes(this.gridOptions)
    },

    // Load Analysis Types
    getTypes(params, type) {
      instance
        .post(masterAPIs.analysisType.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          analysisType: _.get(this.filters, 'analysisType', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.analysisList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'analysisTypeTable',
            this.count > this.pageSize,
          )
          this.loadRefresh = false
          this.loading = false
          this.tableParams = params
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.analysisList = []
      if (sortData.length > 0) {
        this.defaultSortedBy =
          sortData[0]['colId'] === 'analysisType'
            ? 'analysisType'
            : sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'analysisType'
        this.defaultSortOrder = true
      }
      this.getTypes(this.gridOptions, 'sort')
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Get Analysis Type By Id
    getTypeById(id) {
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      instance
        .get(masterAPIs.analysisType.details(id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.analysisType = _.get(
            response.data,
            'result.analysisType',
            null,
          )
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Save Analysis Type
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          instance
            .patch(masterAPIs.analysisType.details(this.form.id), {
              analysisType: this.form.analysisType,
              isActive: this.form.isActive,
            })
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                'Update Analysis Type',
                'Analysis Type updated successfully!',
              )
              if (this.form.id) {
                const newData = [...this.analysisList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.analysisList = newData
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'analysisTypeTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.analysisList = []
      this.selectedRowKeys = []
      this.getTypes(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.analysisList = []
      this.getTypes(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.analysisType,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.analysisType))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getTypes(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'analysisType'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'analysisType',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
